import type { CSSProperties, ReactNode } from "react";
import { Button, Tooltip } from "antd";

export type TableActionButtonTone =
  | "default"
  | "info"
  | "edit"
  | "delete"
  | "download";

export type TableActionButtonItem = {
  key: string;
  label: string;
  icon: ReactNode;
  disabled?: boolean;
  hidden?: boolean;
  danger?: boolean;
  tone?: TableActionButtonTone;
  onClick: () => void;
};

type TableActionButtonsProps = {
  items: TableActionButtonItem[];
  size?: "small" | "middle" | "large";
};

const toneStyles: Record<TableActionButtonTone, CSSProperties> = {
  default: {},
  info: {
    color: "#1677ff",
    borderColor: "#91caff",
    backgroundColor: "#e6f4ff",
  },
  edit: {
    color: "#ad6800",
    borderColor: "#ffd666",
    backgroundColor: "#fff7e6",
  },
  delete: {
    color: "#cf1322",
    borderColor: "#ffa39e",
    backgroundColor: "#fff1f0",
  },
  download: {
    color: "#237804",
    borderColor: "#b7eb8f",
    backgroundColor: "#f6ffed",
  },
};

export const TableActionButtons = ({
  items,
  size = "small",
}: TableActionButtonsProps) => {
  const visibleItems = items.filter((item) => !item.hidden);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {visibleItems.map((item) => (
        <Tooltip key={item.key} title={item.label}>
          <span>
            <Button
              aria-label={item.label}
              danger={item.danger || item.tone === "delete"}
              disabled={item.disabled}
              icon={item.icon}
              size={size}
              style={
                item.disabled ? undefined : toneStyles[item.tone || "default"]
              }
              onClick={item.onClick}
            />
          </span>
        </Tooltip>
      ))}
    </div>
  );
};
